// skillsEvaluationFolder
export const FETCH_SKILLS_EVALUATIONS_INIT = "skillsEvaluationFolder@FETCH_SKILLS_EVALUATIONS_INIT"
export const FETCH_SKILLS_EVALUATIONS_SUCCEDED = "skillsEvaluationFolder@FETCH_SKILLS_EVALUATIONS_SUCCEDED"
export const FETCH_SKILLS_EVALUATIONS_FAILED = "skillsEvaluationFolder@FETCH_SKILLS_EVALUATIONS_FAILED"

export const CLEAR_SKILLS_EVALUATION = "skillsEvaluationFolder@CLEAR_SKILLS_EVALUATION"

export const CREATE_SKILLS_EVALUATION_INIT = "skillsEvaluationFolder@CREATE_SKILLS_EVALUATION_INIT"
export const CREATE_SKILLS_EVALUATION_SUCCEDED = "skillsEvaluationFolder@CREATE_SKILLS_EVALUATION_SUCCEDED"
export const CREATE_SKILLS_EVALUATION_FAILED = "skillsEvaluationFolder@CREATE_SKILLS_EVALUATION_FAILED"

export const FETCH_SKILLS_EVALUATION_INIT = "skillsEvaluationFolder@FETCH_SKILLS_EVALUATION_INIT"
export const FETCH_SKILLS_EVALUATION_SUCCEDED = "skillsEvaluationFolder@FETCH_SKILLS_EVALUATION_SUCCEDED"
export const FETCH_SKILLS_EVALUATION_FAILED = "skillsEvaluationFolder@FETCH_SKILLS_EVALUATION_FAILED"

export const EDIT_SKILLS_EVALUATION_INIT = "skillsEvaluationFolder@EDIT_SKILLS_EVALUATION_INIT"
export const EDIT_SKILLS_EVALUATION_SUCCEDED = "skillsEvaluationFolder@EDIT_SKILLS_EVALUATION_SUCCEDED"
export const EDIT_SKILLS_EVALUATION_FAILED = "skillsEvaluationFolder@EDIT_SKILLS_EVALUATION_FAILED"

export const DEACTIVATE_SKILLS_EVALUATION_INIT = "skillsEvaluationFolder@DEACTIVATE_SKILLS_EVALUATION_INIT"
export const DEACTIVATE_SKILLS_EVALUATION_SUCCEDED = "skillsEvaluationFolder@DEACTIVATE_SKILLS_EVALUATION_SUCCEDED"
export const DEACTIVATE_SKILLS_EVALUATION_FAILED = "skillsEvaluationFolder@DEACTIVATE_SKILLS_EVALUATION_FAILED"

export const ACTIVATE_SKILLS_EVALUATION_INIT = "skillsEvaluationFolder@ACTIVATE_SKILLS_EVALUATION_INIT"
export const ACTIVATE_SKILLS_EVALUATION_SUCCEDED = "skillsEvaluationFolder@ACTIVATE_SKILLS_EVALUATION_SUCCEDED"
export const ACTIVATE_SKILLS_EVALUATION_FAILED = "skillsEvaluationFolder@ACTIVATE_SKILLS_EVALUATION_FAILED"
